import { PrecisionFloat } from '@bts-web/utils-formatting';

export const multiplyTradeAmountByExchangeRate = (
  amount: string,
  rate: NonNullable<PrecisionFloat>,
): PrecisionFloat => {
  if (amount.trim() === '') {
    throw new Error(
      'multiplyTradeAmountByExchangeRate: amount cannot be an empty string',
    );
  }

  if (!rate.value || rate.value.trim() === '') {
    throw new Error(
      'multiplyTradeAmountByExchangeRate: rate.value cannot be empty or undefined',
    );
  }

  const amountNumber = parseFloat(amount);

  const rateNumber = parseFloat(rate.value);

  if (isNaN(amountNumber) || isNaN(rateNumber) || amountNumber === 0) {
    return { value: '0', precision: rate.precision || 8 };
  }

  const result = amountNumber * rateNumber;

  return {
    value: result.toString(),
    precision: rate.precision || 8,
  };
};
